import { TFunction } from 'i18next'
import { z } from 'zod'

export const makeRevisionRequestSchema = (t: TFunction<['checklists']>) =>
  z.object({
    revisionRequestNote: z
      .string()
      .min(1, t('checklists:requestRevisionPopup.note.validation.required'))
      .max(220, t('checklists:requestRevisionPopup.note.validation.maxLength')),
  })

export type RevisionRequestFormData = z.infer<ReturnType<typeof makeRevisionRequestSchema>>
